export default "__VITE_ASSET__BWbxUJYr__"